module.exports = __webpack_public_path__ + "static/media/Girl.bef82b40.png";